import type { 
  GetAffiliateOffersData,
  GetAffiliateOffersResponse,

  GetAffiliateOffersByIdData,
  GetAffiliateOffersByIdResponse,

  GetAffiliateOffersByIdBeforeDeleteData,
  GetAffiliateOffersByIdBeforeDeleteResponse,

  GetAffiliateOffersCatalogByIdBeforeDeleteData,
  GetAffiliateOffersCatalogByIdBeforeDeleteResponse,

  DeleteAffiliateOffersByIdData,
  DeleteAffiliateOffersByIdResponse,

  PostAffiliateOffersData,
  PostAffiliateOffersResponse,

  PutAffiliateOffersByIdData,
  PutAffiliateOffersByIdResponse,

  GetAffiliateOfferTemplatesData,
  GetAffiliateOfferTemplatesResponse,

  PostAffiliateOffersByIdCancelScheduledChangesData,
  PostAffiliateOffersByIdCancelScheduledChangesResponse,

  GetAffiliateOffersCatalogCategoriesData,
  GetAffiliateOffersCatalogCategoriesResponse,

  PostAffiliateOffersCatalogCategoriesData,
  PostAffiliateOffersCatalogCategoriesResponse,

  PutAffiliateOffersCatalogCategoriesByIdData,
  PutAffiliateOffersCatalogCategoriesByIdResponse,

  DeleteAffiliateOffersCatalogCategoriesByIdData,
  DeleteAffiliateOffersCatalogCategoriesByIdResponse,
  
  DeleteAffiliateOffersCatalogByIdData,
  DeleteAffiliateOffersCatalogByIdResponse,

  GetAffiliateOffersCatalogData,
  GetAffiliateOffersCatalogResponse,

  PostAffiliateOffersCatalogData,
  PostAffiliateOffersCatalogResponse,

  PutAffiliateOffersCatalogByIdData,
  PutAffiliateOffersCatalogByIdResponse,

  GetAffiliateOffersCatalogCountData,
  GetAffiliateOffersCatalogCountResponse
} from "@/types/openapi-ts";

import type { AxiosInstance, AxiosRequestConfig } from "axios";

export function getOffersApiModule(affiliatesApi: AxiosInstance) {
  return {
    // offers
    getAffiliateOffers(id: string, params?: GetAffiliateOffersData['query']) {
      return affiliatesApi.get<GetAffiliateOffersResponse>(
        `/affiliate-offers?affiliate_id=${id}`,
        params ? { params } : undefined
      );
    },
    getAffiliateOffer(id: string) {
      return affiliatesApi.get<GetAffiliateOffersByIdResponse>(`/affiliate-offers/${id}`);
    },
    getAffiliateOfferBeforeDelete(id: string) {
      return affiliatesApi.get<GetAffiliateOffersByIdBeforeDeleteResponse>(`/affiliate-offers/${id}/before-delete`);
    },
    getAffiliateOffersCatalogBeforeDelete(id: string) {
      return affiliatesApi.get<GetAffiliateOffersCatalogByIdBeforeDeleteResponse>(`/affiliate-offers-catalog/${id}/before-delete`);
    },
    unpinAffiliateOffer(id: string, v: DeleteAffiliateOffersByIdData['body']) {
      return affiliatesApi.delete<DeleteAffiliateOffersByIdResponse>(`/affiliate-offers/${id}`, { data: v });
    },
    // getOffer(id: string) {
    //   return affiliatesApi.get(`/offers/${id}`);
    // },
    // getOffers() {
    //   return affiliatesApi.get('/offers');
    // },
    addAffiliateOffer(payload: PostAffiliateOffersData['body']) {
      return affiliatesApi.post<PostAffiliateOffersResponse>('/affiliate-offers', payload);
    },
    putAffiliateOffer(id: string, payload: PutAffiliateOffersByIdData['body']) {
      return affiliatesApi.put<PutAffiliateOffersByIdResponse>(`/affiliate-offers/${id}`, payload);
    },
    getAffiliateOfferTemplates() {
      return affiliatesApi.get<GetAffiliateOfferTemplatesResponse>('/affiliate-offer-templates');
    },
    cancelScheduledChanges(id: string) {
      return affiliatesApi.post<PostAffiliateOffersByIdCancelScheduledChangesResponse>(
        `/affiliate-offers/${id}/cancel-scheduled-changes`
      );
    },

    getAffiliateOffersCatalogCategories(params: GetAffiliateOffersCatalogCategoriesData['query']) {
      return affiliatesApi.get<GetAffiliateOffersCatalogCategoriesResponse>(
        '/affiliate-offers-catalog-categories', 
        { params }
      );
    },
    postAffiliateOffersCatalogCategories(payload: PostAffiliateOffersCatalogCategoriesData['body']) {
      return affiliatesApi.post<PostAffiliateOffersCatalogCategoriesResponse>(
        '/affiliate-offers-catalog-categories', 
        payload
      );
    },
    putAffiliateOffersCatalogCategories(id: string, payload: PutAffiliateOffersCatalogCategoriesByIdData['body']) {
      return affiliatesApi.put<PutAffiliateOffersCatalogCategoriesByIdResponse>(
        `/affiliate-offers-catalog-categories/${id}`, 
        payload
      );
    },
    deleteAffiliateOffersCatalogCategories(id: string) {
      return affiliatesApi.delete<DeleteAffiliateOffersCatalogCategoriesByIdResponse>(
        `/affiliate-offers-catalog-categories/${id}`
      );
    },

    deleteAffiliateOffersCatalog(
      id: string, config: 
      AxiosRequestConfig<DeleteAffiliateOffersCatalogByIdData['body']> = {}
    ) {
      return affiliatesApi.delete<DeleteAffiliateOffersCatalogByIdResponse>(
        `/affiliate-offers-catalog/${id}`, 
        config
      );
    },
    getAffiliateOffersCatalog(params?: GetAffiliateOffersCatalogData['query']) {
      return affiliatesApi.get<GetAffiliateOffersCatalogResponse>('/affiliate-offers-catalog', { params });
    },
    postAffiliateOffersCatalog(payload: PostAffiliateOffersCatalogData['body']) {
      return affiliatesApi.post<PostAffiliateOffersCatalogResponse>('/affiliate-offers-catalog', payload);
    },
    putAffiliateOffersCatalog(id: string, payload: PutAffiliateOffersCatalogByIdData['body']) {
      return affiliatesApi.put<PutAffiliateOffersCatalogByIdResponse>(`/affiliate-offers-catalog/${id}`, payload);
    },
    getAffiliateOffersCatalogCount(params: GetAffiliateOffersCatalogCountData['query']) {
      return affiliatesApi.get<GetAffiliateOffersCatalogCountResponse>('/affiliate-offers-catalog/count', { params });
    },
  }
}
